export enum EnumGeofenceZones {
    Estados = 1,
    Municipios = 2,
    Regiones = 3
}